import React from "react";
import { Provider } from "react-redux";
import store from "../redux";
import ConnectedAppRouter from "./ConnectedAppRouter";

const P2PRegistrationApp = () => {
    return (
        <Provider store={store}>
            <ConnectedAppRouter />
        </Provider>
    );
};

export default P2PRegistrationApp;
